/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/AppointmentActions/CheckInPatient/Content/ConfirmationDialog/Content/TooLate/Content"
  
}) {
let dtColorsRed100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.100'
        })
let appointmentActionsAppointmentBookingStartValueData = fromData.useDataValue({ viewPath,
context: 'appointment_actions',
path: 'appointment_booking.start',
})
let appointmentActionsAppointmentBookingLocationTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_actions',
path: 'appointment_booking.location.time_zone_id',
})
let aggregateData = fromHelpers.getDifferenceInMinutes(appointmentActionsAppointmentBookingStartValueData, appointmentActionsAppointmentBookingLocationTimeZoneIdValueData)
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsRed100}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 color={dtColorsRed600}
 data="appointment_actions.appointment_booking.start"
 data="appointment_actions.appointment_booking.location.time_zone_id"
 aggregate="helpers.js getDifferenceInMinutes"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}